import { useStoreContext } from '~/App/Store/CurrentStoreProvider'
import { Avatar, AvatarImage } from '~/DesignSystem/components/avatar'

import { LayoutHeader } from '../../../components/Layout'

const StoreLayoutHeader = () => {
  const { data } = useStoreContext()

  return (
    <LayoutHeader className="flex items-center gap-2">
      {!!data?.attributes.image_url && (
        <Avatar size="xl">
          <AvatarImage src={data?.attributes.image_url} alt={data?.attributes.name} />
        </Avatar>
      )}

      <div>
        <h1 className="text-xl font-medium">{data?.attributes.name}</h1>
        {!!data?.attributes.slogan && <p className="text-sm">{data?.attributes.slogan}</p>}
      </div>
    </LayoutHeader>
  )
}

export default StoreLayoutHeader
